/**
 * The register's pure helpers (members register «pro», 2026-10-31): the list's query string and which person-page tabs
 * a staff member gets. Kept apart from the views so a test can run them without the panel's components.
 */
export type Tab = 'overview' | 'gifts' | 'events' | 'orders' | 'contact';
// event + attended (2026-11-01, «kom medlemmet?»): one event and Påmeldt / Kom / Kom ikke — only offered with events.attendees.read.
export const EMPTY_FILTERS = { status: 'all', age: '', gender: '', tag: '', paid: '', joined: '', app: '', household: '', event: '', attended: '', sort: 'name', dir: '' };
export type Filters = typeof EMPTY_FILTERS;

/** The list's query string: only what is set, so the address stays short and the server's defaults hold. */
export function queryOf(search: string, f: Filters, page = 0): string {
  const p = new URLSearchParams();
  if (search) p.set('q', search);
  for (const [k, v] of Object.entries(f)) if (v && !(k === 'status' && v === 'all') && !(k === 'sort' && v === 'name') && !(k === 'attended' && !f.event)) p.set(k, v);
  if (page) p.set('page', String(page));
  return p.toString();
}

/** Which tabs this staff member gets, from their permissions and the mosque's capabilities. The server checks again. */
export function tabsFor(caps: string[] | null, may: (p: string) => boolean): Tab[] {
  const on = (k: string) => Boolean(caps && caps.includes(k));
  const out: Tab[] = ['overview'];
  if (may('donations.read')) out.push('gifts');
  if (may('events.attendees.read')) out.push('events');
  if (may('store.manage') && on('store')) out.push('orders');
  if ((on('contact_log') && may('members.link')) || (on('tasks') && may('tasks.manage') && may('members.link'))) out.push('contact');
  return out;
}
